import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui-kit";
import { APP } from "@/config";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="band-3-5 min-h-screen bg-[var(--ns-bg)] grid place-items-center px-5">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-[var(--ns-surface)] rounded-[var(--ns-radius)] border border-[var(--ns-border)] p-8 text-center ns-card" data-testid="payment-cancel-page">
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-xl bg-[var(--ns-primary)] text-white grid place-items-center font-head font-bold">N</div>
          <span className="font-head text-lg font-bold">{APP.name}</span>
        </div>
        <XCircle size={48} className="mx-auto text-[var(--ns-subtle)]" />
        <h1 className="font-head text-2xl font-bold mt-3">Checkout cancelled</h1>
        <p className="text-[var(--ns-muted)] mt-2">No charge was made. You can pick a plan whenever you're ready.</p>
        <Button className="mt-6 mx-auto" onClick={() => nav("/parent")}>Back to dashboard</Button>
      </motion.div>
    </div>
  );
}
